import React from 'react'
import {MoreApp} from "@icon-park/react";
import './Our_service.css';

const Our_service = () => {
  return (
    <div className='ourServices' id='ourService'>
        <div className='headerText'>
            <h1>WHAT WE DO</h1>
            <p>Designing Solutions that Empowers</p>
        </div>
        <div className="service-containers">
            <div className="service-item">
                <MoreApp theme="filled" size="40" fill="#F6550D"/>
                <h4>Website Design & Development</h4>
                <span className="bold-text">“Your Vision, Our Process, the Perfect Website”</span>
                <p>
                    <span className="normal-text">At INX Digitals, we go beyond ordinary. Through deep research, precise prototyping, SEO optimization, and boundless creativity, we craft websites designed to make an impact.
                    Every detail counts. Let’s create a digital space where your brand shines!</span>
                </p>
            </div>
            <div className="service-item">
                <div className="service-icon-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14"
                        id="Code-Monitor-1--Streamline-Core"
                        height="40"
                        width="40"
                        style={{ marginRight: '8px', verticalAlign: 'middle' }}
                    >
                        <desc>Code Monitor 1 Streamline Icon: https://streamlinehq.com</desc>
                        <g id="code-monitor-1--code-tags-angle-bracket-monitor">
                            <path
                                id="Subtract"
                                fill="#F6550D"
                                fillRule="evenodd"
                                d="M1.45679 0.5C0.652229 0.5 0 1.15223 0 1.95679v7.58642C0 10.3478 0.65223 11 1.45679 11h4.02627l-0.5352 1.4954h-0.94788c-0.41421 0 -0.75 0.3358 -0.75 0.75s0.33579 0.75 0.75 0.75h6c0.41422 0 0.75002 -0.3358 0.75002 -0.75s-0.3358 -0.75 -0.75002 -0.75h-0.94784L8.51694 11h4.02626C13.3478 11 14 10.3478 14 9.54321V1.95679C14 1.15223 13.3478 0.5 12.5432 0.5H1.45679Zm6.53038 2.28851c0.39296 0.13098 0.60533 0.55572 0.47434 0.94868l-1.5 4.5c-0.13098 0.39296 -0.55572 0.60533 -0.94868 0.47434 -0.39296 -0.13098 -0.60533 -0.55572 -0.47434 -0.94868l1.5 -4.5c0.13098 -0.39296 0.55572 -0.60533 0.94868 -0.47434ZM4.98809 5.06946c0.3145 -0.26956 0.35092 -0.74304 0.08135 -1.05753 -0.26956 -0.3145 -0.74304 -0.35092 -1.05753 -0.08135l-1.75 1.5c-0.16762 0.14367 -0.26342 0.35389 -0.26189 0.57465 0.00153 0.22076 0.10025 0.42963 0.26984 0.57096l1.5 1.25c0.31821 0.26517 0.79113 0.22218 1.05631 -0.09603 0.26517 -0.31821 0.22218 -0.79113 -0.09603 -1.05631l-0.81828 -0.6819 1.07623 -0.92249Zm5.24201 -0.89561c-0.31817 -0.26517 -0.79109 -0.22218 -1.05627 0.09603 -0.26517 0.31821 -0.22218 0.79113 0.09603 1.05631l0.81824 0.6819 -1.07619 0.92249c-0.3145 0.26956 -0.35092 0.74304 -0.08135 1.05753 0.26956 0.3145 0.74304 0.35092 1.05753 0.08135l1.75001 -1.5c0.1676 -0.14367 0.2634 -0.35389 0.2619 -0.57465 -0.0016 -0.22076 -0.1003 -0.42963 -0.2699 -0.57096l-1.5 -1.25Z"
                                clipRule="evenodd"
                                strokeWidth="1"
                            ></path>
                        </g>
                    </svg>
                </div>
                <h4>
                    App & Software Development
                </h4>
                <span className="bold-text">“Building Apps That Work, For You”</span>
                <p>
                    <span className="normal-text">At INX Digitals, we prioritize functionality and user experience to develop reliable, scalable apps and software solutions.
                    Driven by your goals, we create tools that seamlessly fit your needs.
                    Ready to turn your idea into an app that delivers?</span>
                </p>
            </div>
            <div className="service-item">
                <div className="service-icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14"
                        id="Code-Monitor-1--Streamline-Core"
                        // height="40"
                        // width="40"
                        // style={{ marginRight: '8px', verticalAlign: 'middle' }}
                    >
                        <desc>Code Monitor 1 Streamline Icon: https://streamlinehq.com</desc>
                        <g id="code-monitor-1--code-tags-angle-bracket-monitor">
                            <path
                                id="Subtract"
                                fill="#F6550D"
                                fillRule="evenodd"
                                d="M14.25 2.1a1.25 1.25 0 0 0-1.17-.1L6.91 4.43a1.22 1.22 0 0 1-.46.09H2.5a1.25 1.25 0 0 0-1.25 1.25v.1H0v3h1.25V9a1.25 1.25 0 0 0 1.25 1.22L4 13.4a1.26 1.26 0 0 0 1.13.72h.63A1.25 1.25 0 0 0 7 12.87v-2.53l6.08 2.43a1.27 1.27 0 0 0 .47.09 1.29 1.29 0 0 0 .7-.22 1.25 1.25 0 0 0 .55-1V3.13a1.25 1.25 0 0 0-.55-1.03zm-8.5 3.67V9H2.5V5.77zm0 7.1h-.63l-1.23-2.65h1.86zm1.62-3.72A2.29 2.29 0 0 0 7 9V5.7a2.26 2.26 0 0 0 .37-.11l6.18-2.46v8.48zm7.46-3.03v2.5a1.25 1.25 0 0 0 0-2.5z"
                                clipRule="evenodd"
                                strokeWidth="1"
                            ></path>
                        </g>
                    </svg>
                </div>
                <h4>Digital Marketing</h4>
                <span className="bold-text">“Your Brand, Amplified by INX Digitals."</span>
                <p>
                    <span className="normal-text">Our digital marketing solutions cut through the noise with strategies that get results.
                    From social media strategy to targeted ads and content that connects, we help your brand reach and engage the right audience.
                    Let’s make INX Digitals your brand’s megaphone!</span>
                </p>
            </div>
            <div className="service-item">
                <div className="service-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                        <defs>
                            <mask id="ipSCreative0">
                                <g fill="none" stroke-linejoin="round" stroke-width="4">
                                    <path fill="#fff" stroke="#fff" d="M42 39V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3Z"/>
                                    <path fill="#000" stroke="#000" d="m24 18.316l-2.896 5.91l-6.578.954l4.765 4.658l-1.139 6.478L24 33.199l5.849 3.117l-1.13-6.478l4.756-4.658l-6.541-.954z"/>
                                    <path stroke="#000" stroke-linecap="round" d="M18.316 12.632h11.368"/>
                                </g>
                            </mask>
                        </defs>
                        <path fill="#F6550D" d="M0 0h48v48H0z" mask="url(#ipSCreative0)"/>
                    </svg>
                </div>
                <h4>Branding Services</h4>
                <span className="bold-text">“Shaping Identities, Empowering Brands."</span>
                <p>
                    <span className="normal-text">At INX Digitals, we bring brands to life.
                    From compelling logos to cohesive visual identities, we align every design element with your story and goals.
                    Let us help you stand out, connect, and leave a lasting impression. Ready to elevate your brand to iconic status?</span>
                </p>
            </div>
            <div className="service-item">
                <div className="service-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#F6550D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-transform">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M3 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                        <path d="M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3" />
                        <path d="M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3" />
                        <path d="M15 18a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                    </svg>
                </div>
                <h4>IT Consulting & Support</h4>
                <span className="bold-text">“Innovative Solutions, Seamless Operations"</span>
                <p>
                    <span className="normal-text">At INX Digitals, we specialize in transforming challenges into opportunities.
                    Through expert IT consulting and dependable support, we streamline your operations with cutting-edge solutions tailored to your business.
                    Let’s help you harness technology to work smarter, not harder.</span>
                </p>
            </div>
            <div className="service-item">
                <div className="service-icon">
                    <svg width="40" height="40" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3331 15H6.55309C6.1862 15.6355 5.61988 16.1321 4.94195 16.4129C4.26403 16.6937 3.51239 16.743 2.80361 16.5531C2.09483 16.3632 1.46853 15.9447 1.02183 15.3625C0.575133 14.7804 0.333008 14.0671 0.333008 13.3333C0.333008 12.5996 0.575133 11.8863 1.02183 11.3041C1.46853 10.722 2.09483 10.3035 2.80361 10.1136C3.51239 9.92366 4.26403 9.97293 4.94195 10.2537C5.61988 10.5345 6.1862 11.0312 6.55309 11.6667H10.3331V3.33333C10.3331 2.44928 10.6843 1.60143 11.3094 0.976311C11.9345 0.351189 12.7824 0 13.6664 0H26.9998C27.8838 0 28.7317 0.351189 29.3568 0.976311C29.9819 1.60143 30.3331 2.44928 30.3331 3.33333V26.6667C30.3331 27.5507 29.9819 28.3986 29.3568 29.0237C28.7317 29.6488 27.8838 30 26.9998 30H13.6664C12.7824 30 11.9345 29.6488 11.3094 29.0237C10.6843 28.3986 10.3331 27.5507 10.3331 26.6667V15ZM13.6664 15V26.6667H26.9998V3.33333H13.6664V11.6667H17.4464C17.8133 11.0312 18.3796 10.5345 19.0576 10.2537C19.7355 9.97293 20.4871 9.92366 21.1959 10.1136C21.9047 10.3035 22.531 10.722 22.9777 11.3041C23.4244 11.8863 23.6665 12.5996 23.6665 13.3333C23.6665 14.0671 23.4244 14.7804 22.9777 15.3625C22.531 15.9447 21.9047 16.3632 21.1959 16.5531C20.4871 16.743 19.7355 16.6937 19.0576 16.4129C18.3796 16.1321 17.8133 15.6355 17.4464 15H13.6664Z" fill="#F6550D"/>
                    </svg>       
                </div>
                <h4>Product Designing & Prototyping</h4>
                <span className="bold-text">"Ideas Realized, Dreams Prototyped."</span>
                <p>
                    <span className="normal-text">At INX Digitals, we turn concepts into reality with cutting-edge product design and prototyping.
                    By combining innovative thinking, user-centric designs, and rapid iteration, we bring your vision to life. 
                    Let’s create products that inspire, engage, and deliver.</span>
                </p>
            </div>
        </div>
        <a href="#form-container">
            <button className="get_started">Get Started</button>
        </a>
        
    </div>
  )
}

export default Our_service